import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import CustomRangePicker from "../../../components/DateRangePicker";
import DynamicTable from "../../../components/DynamicTable";
import B2BMenu from "../../../components/MenuDropDown/B2BMenu";
import StatusMenu from "../../../components/MenuDropDown/StatusMenu";
import { getSubscriptionHistoryByUserId } from "../../../services/common/subscriptionHistoryApiFn";
import { handleOpenSnackBar } from "../../../utils";
import ExportButton from "./../../../components/ExportButton/index";
import { t } from "i18next";
import InvoicePDF from "../../../components/InvoiceTemplate/InvoicePDF";

const headerData = [
  "transactionId",
  "duration",
  "timeLeft",
  "b2bName",
  "subscriptionName",
  "plan",
  "price",
  "status",
  "Actions",
];

const tableRows = [
  "transactionId",
  "package_duration",
  "package_left_days",
  "user_name_supplier",
  "active_package_name",
  "duration",
  "price",
  "subscription_status",
  "actions",
];

function Invoices() {
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const userData = useSelector((state) => state.userData.user);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  useEffect(() => {
    if (userData) {
      fetchchedSubscriptionHistory();
    }
  }, [userData]);

  const fetchchedSubscriptionHistory = async () => {
    try {
      setIsLoading(true);
      const response = await getSubscriptionHistoryByUserId(userData?.adminId);
      if (response?.data?.status === "success") {
        setSubscriptionHistory(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadInvoice = (row) => {

    console.log(row ,"invoicessssssssssssssssssssssss");
    // Transform subscription data to invoice format
    const invoiceData = {
      invoiceNumber: row.transactionId || `INV-${Date.now()}`,
      invoiceStartDate: new Date(row.startDate).toLocaleDateString(),
      invoiceEndDate: new Date(row.endDate).toLocaleDateString(),
      customer: {
        name: row.username || "Customer",
        email: userData?.email || "customer@example.com",
        phone: userData?.contact || "+1 (555) 123-4567",
      },
      subscription: {
        name: row.subscriptionId.name[currentLanguage] || "Subscription Plan",
        duration: row.duration || "",
        price: parseFloat(row.price) || 0,
      },
      paymentStatus: row.status || "Paid",
      transactionId: row.transactionId || `TXN-${Date.now()}`,
    };

    setSelectedInvoice(invoiceData);
    setIsInvoiceOpen(true);
  };

  const handleCloseInvoice = () => {
    setIsInvoiceOpen(false);
    setSelectedInvoice(null);
  };

  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <B2BMenu />
        <StatusMenu />
        <ExportButton handleClick={() => console.log("helllo")} />
        <CustomRangePicker
          stackProps={{
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
            borderRadius: "6px",
          }}
        />
      </Stack>
    );
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("invoices")}
        secondaryHeading={t("invoiceDownloadNote")}
        // showSerach={true}
        // headProps={renderRightPart()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={subscriptionHistory}
          showDownloadBtn={true}
          handleDownloadInvoice={handleDownloadInvoice}
        />
      </AppContainer>

      {/* Invoice PDF Dialog */}
      <InvoicePDF
        open={isInvoiceOpen}
        onClose={handleCloseInvoice}
        invoiceData={selectedInvoice}
      />
    </>
  );
}

export default Invoices;
